import deepGetState from './deepGetState';
import deepSetState from './deepSetState';
import restore from './restore';



export {
  deepGetState,
  deepSetState,
  restore,
}


// WEBPACK FOOTER //
// ./src/js/store/modules/ls/util/index.js